import { call, put, select } from 'redux-saga/effects';
import { Api } from '../../lib/api';
import { addToasts, clearPolygonOutcomes, getTeamReps, selectTeam } from '../../redux';
import { settings } from '../../settings';
function* handleClearPolygonOutcomes({ payload }) {
    const { polygonIds, callback } = payload;
    try {
        const response = (yield call(Api.clearPolygonOutcomes, polygonIds, settings.salesSeasonId));
        yield put(clearPolygonOutcomes.success(response.data));
        yield put(addToasts([
            {
                type: 'success',
                message: 'Outcomes are cleared',
            },
        ]));
        yield call(callback);
    }
    catch (error) {
        yield put(clearPolygonOutcomes.failure(error));
        yield put(addToasts([
            {
                type: 'error',
                message: 'Failed to clear outcomes', // TODO: pick a message from the error
            },
        ]));
    }
    finally {
        // TODO: is it necessary to reload team reps after clearing outcomes?
        const { team } = (yield select(selectTeam));
        if (team?.id) {
            yield put(getTeamReps.request({ teamId: team.id }));
        }
    }
}
export default handleClearPolygonOutcomes;
